<template>
    <div v-if="state.listCities.length > 0" class="select-city">
        <div v-for="city in state.listCities" :key="city.code">
            <p
                @click="selectCity(city.nom); $emit('onClick')"
                id="color-text"
            >{{ city.nom + " | " + city.departement?.nom + " (" + city.codesPostaux[0] + ")" }}</p>
        </div>
    </div>
    <div
        v-if="state.query.city.length > 0 && state.listCities.length === 0 && dataLoaded === true"
        class="no-result"
    >Aucune ville correspondant</div>
</template>

<script>
import { state } from "../store";

export default {
    name: "ListCities",
    emits: ['onClick'],
    props: {
        dataLoaded: {
            type: Boolean
        }
    },

    setup() {
        const selectCity = (city) => {
            state.query.city = city;
        }

        return { state, selectCity }
    }
}
</script>

<style lang="scss" scoped>
@import "../scss/_variables.scss";

.select-city {
    display: flex;
    flex-direction: column;
    background-color: white;
    width: 100%;
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1000;

    > div {
        padding: 0 1em;
        font-size: 12px;
        border-bottom: 1px solid $base-color;
    }

    div:hover {
        cursor: pointer;
        background-color: $base-color;
        #color-text {
            color: white;
        }
    }
}

.no-result {
    padding: 1em;
    font-size: 12px;
    border-bottom: 1px solid $base-color;
    color: $base-color;
    background-color: white;
}
</style>